/**
 * Takes an array of objects of type T and returns a map of those objects, where
 * the map key is the result of a function called on each T.
 * @param array An array of objects of type T
 * @param keyAccessor A function which, when passed a T, will return a string
 */
interface IKeyedMap<T> {
  [key: string]: T
}

export interface IKeyValuePair<T> {
  key: string
  value: T
}

type KeyAccessor<T> = (item: T) => string

export default class ObjectUtils {
  public static arrayToMap = <T>(
    array: T[],
    keyAccessor: KeyAccessor<T>
  ): IKeyedMap<T> => {
    return array.reduce((map: IKeyedMap<T>, arrItem: T): IKeyedMap<T> => {
      map[keyAccessor(arrItem)] = arrItem
      return map
    }, {})
  }

  public static mapToArray = <T>(map: IKeyedMap<T>): IKeyValuePair<T>[] => {
    if (!map) throw new Error('mapToArray: map is falsy')
    return Object.keys(map).map(
      (key: string): IKeyValuePair<T> => {
        return { key, value: map[key] }
      }
    )
  }

  // public static sortArrayBy = <T>(
  //   arr: T[],
  //   sortFunction: (a: T, b: T) => number
  // ): T[] => {
  //   return arr.sort(sortFunction)
  // }
}
